<header class="header">
  <div class="header-left">
    <div class="brand">
      <img src="/castor_logo_head.png" alt="Castor" class="brand-logo" />
    </div>
    <div class="brand-spacer"></div>
    <nav class="tabs">
      <a routerLink="/customers" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Customers</a>
      <a routerLink="/cruds" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Manage CRUDs</a>
    </nav>
  </div>
  <div class="header-actions">
    <span class="poc-label">POC V0.1</span>
    <button class="btn theme-toggle" type="button" (click)="toggleTheme()" [title]="themeService.theme() === 'light' ? 'Dark mode' : 'Light mode'">
      {{ themeService.theme() === 'light' ? 'Dark mode' : 'Light mode' }}
    </button>
    <button class="btn logout" type="button" (click)="logout()">Logout</button>
  </div>
</header>
<main class="main">
  <router-outlet />
</main>
